import s from './Chip.module.css';

export default function Chip({ selected = false, children, className = '', ...rest }) {
  const cls = [s.chip, selected ? s.selected : ''].filter(Boolean).join(' ');
  return (
    <button type="button" className={`${cls} ${className}`.trim()} {...rest}>
      {children}
    </button>
  );
}
